(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-utilities"] && !Shopify.designMode) return;
  try {
    
  function attestFunction() {
      console.log("attestFunction");
      const attest = document.querySelectorAll(".custom-section-content .hero__image");
      if (attest.length) {
          console.log("attest", attest);
      } else {
          console.log("No elements found with the specified selector.");
      }
  }
  attestFunction();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
